<template>
<div class="chapter">
<div class="inner_page">
<p class="copyright"><a id="page_iv"></a>Copyright © 2006 Fordham University Press</p>
<p class="copyright">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, or any other—except for brief quotations in printed reviews, without the prior permission of the publisher.<br/><br/></p>
<p class="copyright">World War II: The Global, Human, and Ethical Dimension<br/>ISSN 1541-0293<br/><br/></p>
<p class="copyright">Library of Congress Cataloging-in-Publication Data<br/>Whitehead, Don, 1908–<br/>Combat reporter : Don Whitehead’s World War II diary and memoirs / edited by<br/>John B. Romeiser.—1st ed.<br/>p. cm.—(World War II—the global, human, and ethical dimension; 12)<br/>Includes bibliographical references and index.<br/>ISBN-13: 978-0-8232-2675-7<br/>ISBN-10: 0-8232-2675-1<br/>1. Whitehead, Don, 1908–2. World War, 1939–1945—Campaigns—Africa, North<br/>3. World War, 1939–1945—Campaigns—Italy—Sicily. 4. World War, 1939–1945—<br/>Journalists—Diaries. 5. World War, 1939–1945—Personal narratives, American<br/>6. War correspondents—United States—Diaries. I. Romeiser, John Beals, 1948– II. Title.<br/>D766.82.W48 2006<br/>940.54′1373092—dc22<br/>2006021330<br/><br/></p>
<p class="copyright">Printed in the United States of America<br/>08  07  06     5  4  3  2  1<br/>First edition<br/><br/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?07c28cf8